import React, { FunctionComponent } from 'react';
import DashboardLayout from '../../../components/layout/layout';
import { Box, Button, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import TempPasswordIcon from '../../../assets/img/Temp Password.png';

const AdminTempPasswordDisplay: FunctionComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const value = location.state?.value;

  return (
    <>
      <DashboardLayout titleIcon={<img src={TempPasswordIcon} alt="Temp Password" style={{ width: 20, height: 25 }} />} title={"Temp Password"} initialBreadcrumbs={"Extranet"} levelBreadcrumbs={''} breadcrumbs={'Display Temp Password'} activeMenu={'admin'} containerWidth={'80%'}>
        <Typography variant="body1" mb={3}>
          Temp password send to <b>{value}</b> successfully.
        </Typography>

        <Box sx={{ mt: 3, display: "flex", alignItems: "center", gap: 3 }}>
          <Button variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important', minWidth: '100px' }} onClick={() => navigate(`/admin`)}>
            CANCEL
          </Button>
        </Box>
      </DashboardLayout>
    </>
  )
};

export default AdminTempPasswordDisplay;